<template>
  <div class="home-page column-me" :class="{'mobile-mode': isMobile}">
    <!-- Banner -->
    <div class="banner-section column-me center-all">
      <div class="section-content">
        <div class="banner-item">
          <img src="../../assets/img/home/bg_home.png" class="banner-bg" draggable="false">
          <div class="banner-content" v-if="!isMobile">
            <div v-if="nowLanguage==='zh-cn'||nowLanguage==='ja'">
              <img src="../../assets/img/home/home_title1.png" class="w660 h180 objScaleDown" draggable="false">
              <img src="../../assets/img/home/home_title2.png" class="w1000 h180 objScaleDown mT20" draggable="false">
            </div>
            <div v-else>
              <img src="../../assets/img/home/home_title11.png" class="w580 objContain" draggable="false">
            </div>
          </div>
          <div class="banner-content font-n" v-if="isMobile">
            <img src="../../assets/img/home/home_title_m.png" class="w380 objContain" draggable="false">
            <div class="font36 font-l mT10" v-if="$i18n.locale==='zh-cn'||$i18n.locale==='ja'">
              悦唯所至 繁复皆<span class="colorOrange">简</span>
            </div>
            <img src="../../assets/img/go.png" class="img70 objFitCover mT40" draggable="false">
          </div>
        </div>
      </div>
    </div>

    <!--PC端-->
    <template v-if="!isMobile">
      <!-- 产品介绍区 -->
      <div class="product-section column-me center-all animate-section" ref="productSection">
        <div class="section-content pT150">
          <!-- 产品分类标题 -->
          <div class="product-category-title animate-fade-in">
            <img src="../../assets/img/home/go.png" class="img30" draggable="false">
            <span class="mL10 font-l">{{ $t('home.productSolutions') }}</span>
          </div>
          <div class="row-me center-all product-image-container" v-if="productTabs.length > 0">
            <transition name="fade-scale" mode="out-in">
              <div class="h400 row-me center-all" :key="currentTab">
                <img :src="currentProductIcon" class="h400 objScaleDown fade-in" draggable="false"
                     v-if="currentProductIcon">
              </div>
            </transition>
          </div>

          <!-- 产品分类Tab -->
          <div class="row-me center-all">
            <div class="w60Per row-me mT60 space-between">
              <div class="product-tab-new column-me row-center animate-tab"
                   v-for="(tab, index) in productTabs" :key="tab.id"
                   :class="{'product-tab-new-active': currentTab === index}"
                   :style="{animationDelay: `${0.5 + index * 0.15}s`}"
                   @mouseenter="currentTab=index"
                   @click="currentTab = index">
                <div class="tab-number-badge">
                  <span>{{ String(index + 1).padStart(2, '0') }}</span>
                </div>
                <div class="flex1 row-me center-all">
                  <div class="tab-name mT20 font-db">{{ tab.name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row-me center-all mT30 mB50 color-bars">
            <div class="w380 h15 color-bar" style="background: #F7EEF3; animation-delay: 0.8s;"></div>
            <div class="w380 h15 color-bar" style="background: #B2C2E3; animation-delay: 0.95s;"></div>
            <div class="w380 h15 color-bar" style="background: #18A5C2; animation-delay: 1.1s;"></div>
          </div>
        </div>
      </div>
      <!-- 我们的愿景 -->
      <div class="mission-section column-me center-all pTB80 animate-section"
           ref="missionSection">
        <div class="section-content column-me center-all">
          <div class="mission-content row-me row-center mT60">
            <div class="mission-image animate-slide-left">
              <img src="../../assets/img/home/yuanjing.png" style="width: 100%;" draggable="false">
            </div>
            <div class="mission-text column-me flex-end2 mL80 animate-slide-right">
              <img src="../../assets/img/home/go.png" class="img30" draggable="false">
              <div class="font24 colorBlue mT5 font-l">{{ $t('home.ourVision') }}</div>
              <!--中文-->
              <div v-if="nowLanguage==='zh-cn'">
                <div class="mission-title row-me font-n alignR">
                  <img src="../../assets/img/yin.png" class="img30 objScaleDown mT20 mR10" draggable="false">
                  <span class="colorOrange font-sb keep-word">{{
                      $t('home.visionTitle1')
                    }}</span>{{ $t('home.visionText1') }}
                </div>
                <div class="mission-title font-n alignR">
                <span class="colorOrange font-sb keep-word">{{
                    $t('home.visionTitle2')
                  }}</span>{{ $t('home.visionText2') }}
                </div>
              </div>
              <!--英文-->
              <div v-else>
                <div class="mission-title row-me flex-end1 font-n alignR">
                  <div class="column-me">
                    <div class="colorOrange font-sb keep-word row-me flex-end1">
                      <img src="../../assets/img/yin.png" class="img30 objScaleDown mT20 mR10"
                           draggable="false">
                      {{ $t('home.visionTitle1') }}
                    </div>
                    <div class="font55">{{ $t('home.visionText1') }}</div>
                  </div>
                </div>
                <div class="mission-title font-n alignR mT10">
                  <div class="column-me">
                    <div class="colorOrange font-sb keep-word">{{ $t('home.visionTitle2') }}</div>
                    <div class="font55">{{ $t('home.visionText2') }}</div>
                  </div>
                </div>
              </div>
              <div class="mission-btn mT40 pointer font-n" @click="goToAbout">
                <span>{{ $t('home.aboutUs') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 发展历程 -->
      <div class="timeline-section row-me center-all animate-section" ref="timelineSection">
        <div class="section-content posRelative">
          <transition name="fade" mode="out-in">
            <img src="../../assets/img/home/lc.png" class="wh100Per objFitCover timeline-bg-image" draggable="false"
                 key="default">
          </transition>
          <div class="posAbsoluteAll row-me">
            <!-- 标题区域 -->
            <div class="row-me row-center timeline-header">
              <img src="../../assets/img/home/go.png" class="img30 objScaleDown timeline-icon" draggable="false">
              <div class="font24 mL8 font-l timeline-title" style="color: #1B4450;">{{
                  $t('home.developmentHistory')
                }}
              </div>
            </div>
            <!-- 左侧年份选择器 -->
            <div class="timeline-left-panel column-me column-center">
              <!-- 年份选择器 -->
              <div class="column-me row-center timeline-years-selector">
                <el-icon color="#EA8063" :size="28" class="pointer arrow-btn arrow-up"
                         @click="switchToPreviousYear">
                  <ArrowUp/>
                </el-icon>
                <div class="flex1 overflow-auto mTB15" ref="timelineYearsList">
                  <div class="timeline-year-selector-item pointer"
                       v-for="(item, index) in uniqueYearList"
                       :key="item.year"
                       :ref="el => { if (el) timelineYearRefs[index] = el }"
                       :class="{'year-selector-active': selectedYear === item.year}"
                       @click="onSelectYear(item.firstIndex)">
                    {{ item.year }}
                  </div>
                </div>
                <el-icon color="#EA8063" :size="28" class="pointer arrow-btn arrow-down"
                         @click="switchToNextYear">
                  <ArrowDown/>
                </el-icon>
              </div>
            </div>
            <!-- 右侧4个年份卡片 -->
            <div class="timeline-right-cards flex1 posRelative mL120">
              <transition-group name="timeline-card-slide" tag="div" class="timeline-cards-wrapper">
                <div class="timeline-card"
                     v-for="(item, index) in displayedTimelineItems"
                     :key="`${selectYear}-${index}-${item.id || item.year}`"
                     :class="[`timeline-card-${index}`]"
                     :style="getTimelineCardStyle(index)">
                  <div class="timeline-card-year font-l">{{ item.year }}</div>
                  <div class="timeline-card-desc break-word font-l">{{ item.text }}
                  </div>
                </div>
              </transition-group>
            </div>
          </div>
        </div>
      </div>
      <!-- 企业动态 -->
      <div class="news-section column-me center-all pTB80 animate-section" ref="newsSection" v-if="newsData">
        <div class="section-content column-me pTB50">
          <div class="row-me row-center">
            <img :src="newsData.image" class="w50Per objContain animate-slide-left" draggable="false">
            <div class="w50Per column-me flex-end2 pR180 animate-slide-right font-l">
              <img src="../../assets/img/home/go.png" class="img30" draggable="false">
              <div class="font24 colorBlue mT10">{{ $t('home.enterpriseDynamics') }}</div>
              <div class="row-me row-center mT30 font27 colorBlue font-m">
                <div v-if="newsData.category">{{ newsData.category }}&nbsp;｜&nbsp;</div>
                <div>{{ newsData.date }}</div>
              </div>
              <div class="news-desc font34 colorBlue alignR mT30" style="color: #2C2B30">
                {{ newsData.title }}
              </div>
              <div class="more-link pointer mT30 font-n" @click="goToNewsDetail(newsData.id)">
                <span>{{ $t('common.learnMore') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 学术资讯 -->
      <div class="academic-section column-me center-all pTB80 animate-section" ref="academicSection">
        <div class="section-content column-me">
          <div class="row-me row-center mL180 academic-title-wrapper">
            <img src="../../assets/img/home/go.png" class="img30" draggable="false">
            <span class="font24 colorBlue mL10 font-l">{{ $t('home.academicInfo') }}</span>
          </div>
          <div class="h480 posRelative mT30">
            <div class="h200" style="background: #F7EEF3"></div>
            <div class="posAbsoluteAll">
              <div class="row-me flex-sb mL180 mR180">
                <div class="item-academic flex1 mR20 pointer animate-card"
                     v-for="(item, index) in academicList" :key="index"
                     :style="{animationDelay: `${index * 0.15}s`}"
                     @click="goToArticleDetail(item)">
                  <div class="w100Per h200 academic-image-wrapper">
                    <img :src="item.image" class="academic-image" draggable="false">
                  </div>
                  <div class="academic-content pL15 mT20 column-me">
                    <div class="row-me row-center font20 colorBlue font-bold academic-text font-m">
                      <div v-if="item.title">{{ item.title }}&nbsp;|&nbsp;</div>
                      <div>{{ item.date }}</div>
                    </div>
                    <div class="font24 colorBlue mT10 academic-text font-l line2" :title="item.desc">
                      {{ item.desc }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row-me center-all mT30">
                <div class="more-link pointer mT30 font-n" @click="goToAcademic">
                  <span>{{ $t('common.learnMore') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!--手机端-->
    <div class="mobile-div" v-if="isMobile">
      <!-- 产品介绍区 -->
      <div class="w100Per mobile-product-section" ref="mobileProductSection">
        <div class="row-me row-center pTB50 pLR60 section-header">
          <div class="font36 font-db flex1">{{ $t('home.productSolutions') }}</div>
          <div class="btn-go row-me center-all" @click="goToProducts">
            <div>{{ $t('home.productCenter') }}</div>
            <img src="../../assets/img/go.png" class="img30 mL10 objScaleDown" draggable="false">
          </div>
        </div>
        <div class="h630 p-card column-me product-card pointer"
             v-for="(tab, index) in productTabs" :key="tab.id"
             :style="{animationDelay: `${0.1 + index * 0.1}s`}"
             @click="goToProductCategory(index)">
          <div class="mL60 pT30 card-content">
            <div class="p-number">{{ String(index + 1).padStart(2, '0') }}</div>
            <div class="font32 colorBlack font-db mT23">{{ tab.name }}</div>
          </div>
          <div class="flex1 pLR60 card-image">
            <img :src="tab.icon" class="wh100Per objContain" draggable="false" v-if="tab.icon">
          </div>
          <div class="flex1"></div>
          <div class="row-me flex-end1 mB30 mT30 mR60 card-dots">
            <div :class="dotIndex === index ? 'p2' : 'p1'" v-for="(dotItem, dotIndex) in productTabs.length"
                 :key="dotIndex"
                 :style="{marginLeft: dotIndex > 0 ? '10px' : '0'}"></div>
          </div>
        </div>
      </div>
      <!-- 我们的愿景 -->
      <div class="w100Per h950 posRelative mobile-vision-section" ref="mobileVisionSection">
        <div class="row-me row-center pTB50 pLR60 section-header">
          <div class="font36 font-db flex1">{{ $t('home.ourVision') }}</div>
          <div class="btn-go row-me center-all" @click="goToAbout">
            <div>{{ $t('home.aboutUs') }}</div>
            <img src="../../assets/img/go.png" class="img30 mL10 objScaleDown" draggable="false">
          </div>
        </div>
        <div class="posAbsoluteAll vision-image row-me row-center">
          <img src="../../assets/img/home/组%20384.png" class="w450 objContain" draggable="false">

          <div class="flex1 column-me column-center mT100 mR60 flex-end2"
               v-if="nowLanguage==='zh-cn'||nowLanguage==='ja'">
            <div class="point-vision mR15"></div>
            <div class="row-me center-all font40 font-n mT10">
              <div class="vertical-text">
                <span class="colorOrange font-db">{{ $t('home.visionTitle2') }}</span>{{ $t('home.visionText2') }}
              </div>
              <div class="vertical-text">
                <span class="colorOrange font-db">{{ $t('home.visionTitle1') }}</span>{{ $t('home.visionText1') }}
              </div>
            </div>
          </div>
          <div class="vision-text column-me flex-end2 alignR" v-else>
            <div class="point-vision"></div>
            <div class="font40 font-n mT10">
              <div class="colorOrange font-db">{{ $t('home.visionTitle1') }}</div>
              <div class="font33">{{ $t('home.visionText1') }}</div>
              <div class="colorOrange font-db mT20">{{ $t('home.visionTitle2') }}</div>
              <div class="font33">{{ $t('home.visionText2') }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 发展历程 -->
      <div class="timeline-div column-me" ref="mobileTimelineSection">
        <div class="row-me row-center pTB50 pLR60 section-header">
          <div class="font36 font-db flex1">{{ $t('home.developmentHistory') }}</div>
          <div class="btn-go row-me center-all" @click="goToAbout">
            <div>{{ $t('common.viewDetails') }}</div>
            <img src="../../assets/img/go.png" class="img30 mL10 objScaleDown" draggable="false">
          </div>
        </div>
        <div class="flex1 section-content posRelative">
          <img src="../../assets/img/home/组%20385.png" class="objContain timeline-bg" draggable="false"
               key="default">
          <div class="posAbsoluteAll column-me overflow-auto">
            <div class="column-me mL100 pB50 timeline-years overflow-auto fit-content-x">
              <el-icon color="#EA8063" :size="isMobile?60:35" class="pointer arrow-btn arrow-up"
                       @click="switchToPreviousYear">
                <ArrowUp/>
              </el-icon>
              <div class="flex1 overflow-auto mTB30" ref="mobileTimelineYearsList">
                <div class="timeline-items-wrapper" ref="mobileTimelineItemsWrapper">
                  <div class="timeline-year-item row-me pointer" v-for="(item, index) in timelineList"
                       :key="index" :ref="el => { if (el) mobileTimelineYearRefs[index] = el }"
                       :class="{'timeline-year-active': selectYear === index}"
                       :style="{animationDelay: `${index * 0.1}s`}" @click="onSelectYear(index)">
                    <div v-if="index!==timelineList.length-1" class="timeline-line-segment"></div>
                    <div class="point-wrapper">
                      <div class="point mT5" :class="{'point-a':selectYear===index}">
                        <div class="point-pulse" v-if="selectYear===index"></div>
                      </div>
                    </div>
                    <div class="column-me mL60 timeline-text-content">
                      <div class="font38 timeline-year font-n" :class="{'year-active': selectYear===index}">
                        {{ item.year }}
                      </div>
                      <div class="font24 mT5 timeline-desc" :class="selectYear===index?'font-db desc-active':'font-n'">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-icon color="#EA8063" :size="isMobile?60:35" class="pointer arrow-btn arrow-down"
                       @click="switchToNextYear">
                <ArrowDown/>
              </el-icon>
            </div>
          </div>
        </div>
      </div>
      <!-- 企业动态 -->
      <div class="w100Per column-me mobile-news-section" ref="mobileNewsSection" v-if="newsData">
        <div class="row-me row-center pTB50 pLR60 section-header">
          <div class="font36 font-db flex1">{{ $t('home.newsCenter') }}</div>
          <div class="btn-go row-me center-all" @click="goToNews">
            <div>{{ $t('home.enterpriseDynamics') }}</div>
            <img src="../../assets/img/go.png" class="img30 mL10 objScaleDown" draggable="false">
          </div>
        </div>
        <div class="news-image-wrapper pointer" @click="goToNewsDetail(newsData.id)">
          <img :src="newsData.image" class="w100Per h330 objFitCover news-image" draggable="false">
        </div>
        <div class="flex1 bgcFA row-me news-content pointer" @click="goToNewsDetail(newsData.id)">
          <div class="w14 h100Per news-bar" style="background: #EA8063;"></div>
          <div class="flex1 colorBlack column-me pL50 pR60 pT30 pB25 news-text">
            <div class="flex1 font34 font-m line3">{{ newsData.title }}</div>
            <div class="row-me row-center mT30">
              <div class="row-me row-center flex1 font20 font-m">
                <div v-if="newsData.category">{{ newsData.category }}&nbsp;｜&nbsp;</div>
                <div>{{ newsData.date }}</div>
              </div>
              <img src="../../assets/img/rt.png" class="img30 objContain news-arrow" draggable="false">
            </div>
          </div>
        </div>
      </div>
      <!-- 学术资讯 -->
      <div class="w100Per column-me mobile-academic-section" ref="mobileAcademicSection">
        <div class="row-me row-center pTB50 pLR60 section-header">
          <div class="font36 font-db flex1">{{ $t('home.academicInfo') }}</div>
          <div class="btn-go row-me center-all" @click="goToAcademic">
            <div>{{ $t('common.learnMore') }}</div>
            <img src="../../assets/img/go.png" class="img30 mL10 objScaleDown" draggable="false">
          </div>
        </div>
        <div class="flex1" @touchstart="onTouchStart" @touchend="onTouchEnd">
          <el-carousel ref="refSwiper" :interval="3000" height="7.5rem" arrow="never" indicator-position="none"
                       :autoplay="swiperAutoplay" @change="swiperChange">
            <el-carousel-item v-for="(item, index) in academicList" :key="index">
              <div class="pLR60 pB50 column-me h100Per pointer" @click="goToArticleDetail(item)">
                <img :src="item.image" class="w100Per h250 objFitCover" draggable="false">
                <div class="font26 mT23 font-m line2">{{ item.desc }}</div>
                <div class="flex1 font20 mT23 font-n line3" style="color: #7F7E7E;">
                  {{ $t('home.academicDetailText') }}
                </div>
                <div class="row-me row-center">
                  <div class="flex1 row-me row-center font20 font-m">
                    <div v-if="item.title">{{ item.title }} ｜</div>
                    <div>{{ item.date }}</div>
                  </div>
                  <div class="mLR10" :class="nowSwiperIndex===idx?'ps2':'ps1'" v-for="(a, idx) in academicList"
                       :key="idx" @click.stop="clickSwiper(idx)"></div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ArrowDown, ArrowRight, ArrowUp} from "@element-plus/icons";
import {deviceState} from "@/utils/device";
import {getHomeAcademic, getHomeDevelopment, getHomeNews, getImageUrl, getProductCategories} from "@/http/api";
import bus from "@/assets/js/bus";
import {getLanguage} from "../../i18n";

export default {
  components: {
    ArrowRight, ArrowUp, ArrowDown
  },
  data() {
    return {
      deviceState, // 引用全局设备状态
      currentTab: 0,
      // 发展历程
      currentYear: 0,
      timelineYearRefs: [],
      mobileTimelineYearRefs: [], // 手机端年份项引用
      selectYear: 0,
      timelineInitialized: false, // 控制时间线卡片初始化动画
      // 发展历程数据（从API获取）
      timelineData: [],
      // 推荐企业动态（从API获取）
      recommendNews: null,
      // 推荐学术资讯（从API获取）
      recommendAcademicList: [],
      // 产品分类（从API获取）
      apiProductCategories: [],
      nowSwiperIndex: 0,
      // 触摸滑动相关
      touchStartX: 0,
      touchStartY: 0,
      swiperAutoplay: true,
      nowLanguage: '',
    }
  },
  created() {
    // 确保在创建时就检查是否是手机端
    if (this.isMobile) {
      // 手机端初始化时延迟很短的时间确保DOM准备好
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkVisibleSections()
        }, 50)
      })
    }
    // 数据加载移到 activated 中，避免首次进入时重复调用
  },
  mounted() {
    this.nowLanguage = getLanguage()
    this.initScrollAnimation()
    // 确保页面加载时立即检查可见区域
    this.$nextTick(() => {
      this.checkVisibleSections()
    })
    // 监听语言切换事件，重新加载数据
    bus.$on('language-changed', this.onLanguageChanged)
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
    // 移除语言切换事件监听
    bus.$off('language-changed', this.onLanguageChanged)
  },
  activated() {
    // 当使用 keep-alive 时，重新加载数据和触发动画
    this.loadHomeData()
    this.$nextTick(() => {
      this.resetAnimations()
      // 重新检查可见区域
      setTimeout(() => {
        this.checkVisibleSections()
      }, 100)
    })
  },
  methods: {
    // 语言切换时重新加载数据
    onLanguageChanged() {
      this.nowLanguage = getLanguage()
      this.loadHomeData()
    },
    // 加载首页数据
    async loadHomeData() {
      // 并行请求四个接口
      try {
        const [developmentRes, newsRes, academicRes, categoriesRes] = await Promise.all([
          getHomeDevelopment(),
          getHomeNews(),
          getHomeAcademic(),
          getProductCategories()
        ])
        // 处理发展历程数据
        if (developmentRes && developmentRes.code === 200 && developmentRes.data) {
          this.timelineData = developmentRes.data.map(item => ({
            id: item.id,
            year: item.eventTime,
            text: item.title
          }))
        }
        // 处理推荐企业动态数据
        if (newsRes && newsRes.code === 200 && newsRes.data) {
          this.recommendNews = {
            id: newsRes.data.id,
            title: newsRes.data.title,
            category: newsRes.data.categoryName,
            date: newsRes.data.publishTime ? newsRes.data.publishTime.split(' ')[0].replace(/-/g, '/') : '',
            image: getImageUrl(newsRes.data.coverImage),
            summary: newsRes.data.summary
          }
        }
        // 处理推荐学术资讯数据
        if (academicRes && academicRes.code === 200 && academicRes.data) {
          this.recommendAcademicList = academicRes.data.map((item) => ({
            id: item.id,
            title: item.categoryName || '',
            date: item.publishTime ? item.publishTime.split(' ')[0].replace(/-/g, '/') : '',
            desc: item.title,
            image: getImageUrl(item.coverImage)
          }))
        }
        // 处理产品分类数据
        if (categoriesRes && categoriesRes.code === 200 && categoriesRes.data) {
          this.apiProductCategories = categoriesRes.data.map((item) => ({
            id: item.id,
            name: item.name,
            icon: getImageUrl(item.icon1)
          }))
        }
        // 数据加载完成后，重新初始化动画观察器（因为v-if条件元素此时才渲染）
        this.$nextTick(() => {
          this.reinitAnimationObserver()
        })
      } catch (error) {
        console.error('加载首页数据失败:', error)
      }
    },
    // 重新初始化动画观察器（用于v-if条件渲染的元素）
    reinitAnimationObserver() {
      // 观察所有需要动画的部分（PC端和手机端）
      const sections = this.isMobile ? [
        this.$refs.mobileProductSection,
        this.$refs.mobileVisionSection,
        this.$refs.mobileTimelineSection,
        this.$refs.mobileNewsSection,
        this.$refs.mobileAcademicSection
      ] : [
        this.$refs.productSection,
        this.$refs.missionSection,
        this.$refs.timelineSection,
        this.$refs.newsSection,
        this.$refs.academicSection
      ]

      sections.forEach(section => {
        if (section && this.observer) {
          // 重新观察元素
          this.observer.observe(section)
        }
      })
      // 立即检查可见区域
      this.checkVisibleSections()
    },
    swiperChange(current, prev) {
      this.nowSwiperIndex = current
    },
    clickSwiper(index) {
      this.$refs.refSwiper.setActiveItem(index)
    },
    // 触摸开始
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
    },
    // 触摸结束
    onTouchEnd(e) {
      const touchEndX = e.changedTouches[0].clientX
      const touchEndY = e.changedTouches[0].clientY
      const deltaX = touchEndX - this.touchStartX
      const deltaY = touchEndY - this.touchStartY

      // 判断是否为水平滑动（水平距离大于垂直距离，且水平距离大于50px）
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
        const total = this.academicList.length
        let newIndex
        if (deltaX > 0) {
          // 向右滑动，切换到上一张
          newIndex = (this.nowSwiperIndex - 1 + total) % total
        } else {
          // 向左滑动，切换到下一张
          newIndex = (this.nowSwiperIndex + 1) % total
        }
        this.$refs.refSwiper.setActiveItem(newIndex)
        // 重启自动播放
        this.restartSwiperAutoplay()
      }
    },
    // 重启自动播放
    restartSwiperAutoplay() {
      this.swiperAutoplay = false
      this.$nextTick(() => {
        this.swiperAutoplay = true
      })
    },
    // 重置所有动画
    resetAnimations() {
      // 重置时间线初始化状态，以便重新触发动画
      this.timelineInitialized = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.timelineInitialized = true
        }, 300)
      })
      // 重置滚动触发的区块动画（PC端和手机端）
      const sections = this.isMobile ? [
        this.$refs.mobileProductSection,
        this.$refs.mobileVisionSection,
        this.$refs.mobileTimelineSection,
        this.$refs.mobileNewsSection,
        this.$refs.mobileAcademicSection
      ] : [
        this.$refs.productSection,
        this.$refs.missionSection,
        this.$refs.timelineSection,
        this.$refs.newsSection,
        this.$refs.academicSection
      ]

      sections.forEach(section => {
        if (section) {
          section.classList.remove('animate-in')
        }
      })

      // 重置 CSS 动画 - 强制重新触发
      this.$nextTick(() => {
        // 重置 banner 动画
        const bannerContent = document.querySelector('.banner-content')
        if (bannerContent) {
          bannerContent.style.animation = 'none'
          setTimeout(() => {
            bannerContent.style.animation = ''
          }, 10)
        }

        // 重置产品标题动画
        const productTitle = document.querySelector('.product-category-title')
        if (productTitle) {
          productTitle.style.animation = 'none'
          setTimeout(() => {
            productTitle.style.animation = ''
          }, 10)
        }

        // 重置产品 Tab 动画
        const productTabs = document.querySelectorAll('.animate-tab')
        productTabs.forEach(tab => {
          tab.style.animation = 'none'
          setTimeout(() => {
            tab.style.animation = ''
          }, 10)
        })

        // 重置彩色条动画
        const colorBars = document.querySelectorAll('.color-bar')
        colorBars.forEach(bar => {
          bar.style.animation = 'none'
          setTimeout(() => {
            bar.style.animation = ''
          }, 10)
        })

        // 重置学术卡片动画
        const academicCards = document.querySelectorAll('.animate-card')
        academicCards.forEach(card => {
          card.style.animation = 'none'
          setTimeout(() => {
            card.style.animation = ''
          }, 10)
        })

        // 重置时间线年份动画
        const timelineYears = document.querySelectorAll('.timeline-year-item')
        timelineYears.forEach(year => {
          year.style.animation = 'none'
          setTimeout(() => {
            year.style.animation = ''
          }, 10)
        })

        // 重置学术标题动画
        const academicTitle = document.querySelector('.academic-title-wrapper')
        if (academicTitle) {
          academicTitle.style.animation = 'none'
          setTimeout(() => {
            academicTitle.style.animation = ''
          }, 10)
        }
      })
    },
    // 初始化滚动动画
    initScrollAnimation() {
      const options = {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 进入视口时添加动画类
            entry.target.classList.add('animate-in')
            // 如果是发展历程区域，触发卡片移入动画
            if (entry.target === this.$refs.timelineSection && !this.timelineInitialized) {
              setTimeout(() => {
                this.timelineInitialized = true
              }, 100)
            }
          }
          // 不移除动画类，让动画只播放一次直到页面重置
        })
      }, options)

      // 观察所有需要动画的部分（PC端和手机端）
      const sections = this.isMobile ? [
        this.$refs.mobileProductSection,
        this.$refs.mobileVisionSection,
        this.$refs.mobileTimelineSection,
        this.$refs.mobileNewsSection,
        this.$refs.mobileAcademicSection
      ] : [
        this.$refs.productSection,
        this.$refs.missionSection,
        this.$refs.timelineSection,
        this.$refs.newsSection,
        this.$refs.academicSection
      ]

      sections.forEach(section => {
        if (section) {
          this.observer.observe(section)
        }
      })
    },
    // 检查当前视口中可见的区块，立即触发它们的动画
    checkVisibleSections() {
      // 根据设备类型选择不同的sections
      const sections = this.isMobile ? [
        this.$refs.mobileProductSection,
        this.$refs.mobileVisionSection,
        this.$refs.mobileTimelineSection,
        this.$refs.mobileNewsSection,
        this.$refs.mobileAcademicSection
      ] : [
        this.$refs.productSection,
        this.$refs.missionSection,
        this.$refs.timelineSection,
        this.$refs.newsSection,
        this.$refs.academicSection
      ]

      sections.forEach(section => {
        if (section) {
          const rect = section.getBoundingClientRect()
          const windowHeight = window.innerHeight || document.documentElement.clientHeight

          // 手机端使用更宽松的判断条件，确保内容能及时显示
          const threshold = this.isMobile ? 0.95 : 0.85

          // 如果元素在视口中或接近视口
          if (rect.top < windowHeight * threshold && rect.bottom > 0) {
            section.classList.add('animate-in')
            // 如果是发展历程区域，触发卡片移入动画
            if (section === this.$refs.timelineSection && !this.timelineInitialized) {
              setTimeout(() => {
                this.timelineInitialized = true
              }, 100)
            }
          }
        }
      })
    },
    // 跳转到产品中心
    goToProducts() {
      this.$router.push('/products')
    },
    // 跳转到产品列表（按分类索引）
    goToProductCategory(index) {
      this.$router.push({
        path: '/products',
        query: {tab: index}
      })
    },
    // 跳转到关于我们
    goToAbout() {
      this.$router.push('/aboutUs')
    },
    // 跳转到企业动态
    goToNews() {
      this.$router.push('/news')
    },
    // 跳转到新闻详情
    goToNewsDetail(id) {
      this.$router.push({
        path: '/newsDetail',
        query: {id: id}
      })
    },
    // 跳转到学术资讯
    goToAcademic() {
      this.$router.push('/academic')
    },
    // 跳转到文章详情
    goToArticleDetail(item) {
      this.$router.push({
        path: '/articleDetail',
        query: {id: item.id || 1}
      })
    },
    // 切换到上一个年份（按去重后的年份列表）
    switchToPreviousYear() {
      const currentYearIndex = this.uniqueYearList.findIndex(item => item.year === this.selectedYear)
      if (currentYearIndex > 0) {
        this.selectYear = this.uniqueYearList[currentYearIndex - 1].firstIndex
        this.scrollToSelectedYear()
      }
    },
    // 切换到下一个年份（按去重后的年份列表）
    switchToNextYear() {
      const currentYearIndex = this.uniqueYearList.findIndex(item => item.year === this.selectedYear)
      if (currentYearIndex < this.uniqueYearList.length - 1) {
        this.selectYear = this.uniqueYearList[currentYearIndex + 1].firstIndex
        this.scrollToSelectedYear()
      }
    },
    // 选择年份
    onSelectYear(index) {
      this.selectYear = index
      this.scrollToSelectedYear()
    },
    // 滚动到选中的年份
    scrollToSelectedYear() {
      this.$nextTick(() => {
        const container = this.$refs.timelineYearsList
        // 找到当前选中年份在uniqueYearList中的索引
        const yearIndex = this.uniqueYearList.findIndex(item => item.year === this.selectedYear)
        const selectedItem = this.timelineYearRefs[yearIndex]
        if (container && selectedItem) {
          // 计算选中项相对于容器的位置
          const containerRect = container.getBoundingClientRect()
          const itemRect = selectedItem.getBoundingClientRect()
          // 计算需要滚动的距离，使选中项居中显示
          const scrollTop = container.scrollTop + (itemRect.top - containerRect.top) - (containerRect.height / 2) + (itemRect.height / 2)
          container.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          })
        }
      })
    },
    // 获取时间线卡片的样式（沿斜线定位）
    getTimelineCardStyle(index) {
      // 根据背景图片的斜线角度计算位置
      // 斜线从左下到右上，角度约33度（tan(33°) ≈ 0.65）
      // 基准位置：第一个卡片在左下角
      const baseTop = 0    // 基准顶部距离
      const baseRight = 20      // 基准右侧距离
      const horizontalStep = 260   // 水平间距
      const verticalStep = 160    // 垂直间距

      return {
        top: `${(baseTop + (4 - index) * verticalStep) / 80}rem`,
        right: `${(baseRight + (4 - index) * horizontalStep) / 80}rem`
      }
    }
  },
  computed: {
    isMobile() {
      return this.deviceState.isMobile
    },
    // 产品Tab - 从API获取产品分类
    productTabs() {
      return this.apiProductCategories || []
    },
    // 当前选中分类的图标
    currentProductIcon() {
      if (this.productTabs.length > 0 && this.currentTab < this.productTabs.length) {
        return this.productTabs[this.currentTab].icon || ''
      }
      return ''
    },
    // 发展历程列表 - 完全从API获取
    timelineList() {
      return this.timelineData || []
    },
    // 学术资讯列表 - 完全从API获取
    academicList() {
      return this.recommendAcademicList || []
    },
    // 企业动态 - 完全从API获取
    newsData() {
      return this.recommendNews || null
    },
    // 显示的时间线项目（从当前选中年份开始的4个）
    displayedTimelineItems() {
      // 初始化动画：未初始化时返回空数组，初始化后显示数据触发enter动画
      if (!this.timelineInitialized) {
        return []
      }
      if (!this.timelineList || this.timelineList.length === 0) {
        return []
      }
      const total = this.timelineList.length
      // 确保显示4个，如果从当前位置开始不足4个，则从末尾往前取
      let startIndex = this.selectYear
      if (startIndex + 4 > total) {
        startIndex = Math.max(0, total - 4)
      }
      return this.timelineList.slice(startIndex, startIndex + 4)
    },
    // 去重后的年份列表（左侧选择器使用）
    uniqueYearList() {
      if (!this.timelineList || this.timelineList.length === 0) {
        return []
      }
      const seen = new Set()
      const result = []
      this.timelineList.forEach((item, index) => {
        if (!seen.has(item.year)) {
          seen.add(item.year)
          result.push({
            year: item.year,
            firstIndex: index  // 记录该年份在原始列表中的第一个索引
          })
        }
      })
      return result
    },
    // 当前选中的年份值
    selectedYear() {
      if (this.timelineList && this.timelineList.length > 0 && this.selectYear < this.timelineList.length) {
        return this.timelineList[this.selectYear].year
      }
      return null
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        // 当路由变化且是进入首页时，重置动画
        if (to.path === '/home' && from && from.path !== '/home') {
          // 从其他页面进入首页，延迟重置以确保 DOM 已更新
          setTimeout(() => {
            this.resetAnimations()
            // 滚动到顶部
            window.scrollTo({top: 0, behavior: 'instant'})
            // 重新检查可见区域并触发动画
            this.$nextTick(() => {
              this.checkVisibleSections()
            })
          }, 50)
        }
      },
      immediate: false
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-div {
  .point-vision {
    width: 15px;
    height: 15px;
    background: #f3d8d1;
    border-radius: 50%;
  }

  .vertical-text {
    writing-mode: vertical-rl; /* 从上到下排列，默认为从左到右 */
    text-orientation: upright; /* 使文字正常显示，而非旋转 */
    max-height: 700px;
    word-wrap: break-word;
  }

  // 通用section头部动画
  .section-header {
    opacity: 0;
    transform: translateY(-20px);
    transition: all 0.6s ease-out;
  }

  .btn-go {
    padding: 8px 15px;
    background: #EDEDF1;
    border-radius: 50px;
    font-size: 21px;
    color: #454F5E;
    text-align: center;
    font-family: font-n, serif;
    transition: all 0.3s ease;

    &:active {
      transform: scale(0.95);
      background: #E0E0E4;
    }
  }

  // ========== 产品介绍区动画 ==========
  .mobile-product-section {
    .product-card {
      opacity: 0;
      transform: translateY(40px);
      transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);

      .card-content {
        opacity: 0;
        transform: translateX(-30px);
        transition: all 0.5s ease-out 0.2s;
      }

      .card-image img {
        opacity: 0;
        transform: scale(0.9);
        transition: all 0.6s ease-out 0.3s;
      }

      .card-dots {
        opacity: 0;
        transition: all 0.4s ease-out 0.5s;
      }
    }

    &.animate-in {
      .section-header {
        opacity: 1;
        transform: translateY(0);
      }

      .product-card {
        opacity: 1;
        transform: translateY(0);

        .card-content {
          opacity: 1;
          transform: translateX(0);
        }

        .card-image img {
          opacity: 1;
          transform: scale(1);
        }

        .card-dots {
          opacity: 1;
        }
      }
    }
  }

  // ========== 愿景区动画 ==========
  .mobile-vision-section {
    .vision-image {
      opacity: 0;
      transform: scale(0.95) translateX(30px);
      transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.2s;
    }

    &.animate-in {
      .section-header {
        opacity: 1;
        transform: translateY(0);
      }

      .vision-image {
        opacity: 1;
        transform: scale(1) translateX(0);

        .vision-text {
          position: absolute;
          right: 60px;
          top: 500px;
          width: 350px;
        }
      }
    }
  }

  // ========== 企业动态区动画 ==========
  .mobile-news-section {
    .news-image-wrapper {
      overflow: hidden;

      .news-image {
        opacity: 0;
        transform: scale(1.1);
        transition: all 0.7s ease-out 0.2s;
      }
    }

    .news-content {
      opacity: 0;
      transform: translateY(30px);
      transition: all 0.6s ease-out 0.4s;
    }

    .news-bar {
      transform: scaleY(0);
      transform-origin: top;
      transition: transform 0.5s ease-out 0.6s;
    }

    .news-text {
      opacity: 0;
      transform: translateX(-20px);
      transition: all 0.5s ease-out 0.7s;
    }

    .news-arrow {
      opacity: 0;
      transform: translateX(-10px);
      transition: all 0.4s ease-out 0.8s;
    }

    &.animate-in {
      .section-header {
        opacity: 1;
        transform: translateY(0);
      }

      .news-image {
        opacity: 1;
        transform: scale(1);
      }

      .news-content {
        opacity: 1;
        transform: translateY(0);
      }

      .news-bar {
        transform: scaleY(1);
      }

      .news-text {
        opacity: 1;
        transform: translateX(0);
      }

      .news-arrow {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }

  // ========== 学术资讯区动画 ==========
  .mobile-academic-section {
    &.animate-in {
      .section-header {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  .p-card {
    background: linear-gradient(351deg, #F9F9F9 0%, #F5F7F8 37.37%, #ECF3F8 65.5%, #DCEDF7 90.52%, #D4EAF7 100%);
    border-bottom: 10px solid #F7EEF3;

    .p-number {
      width: 50px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #EA8063;
      border-radius: 19px 19px 19px 19px;
      font-size: 33px;
      color: #FFFFFF;
      font-family: font-n, serif;
    }

    .p1 {
      width: 15px;
      height: 15px;
      background: #f3d8d1;
      border-radius: 50%;
    }

    .p2 {
      width: 15px;
      height: 15px;
      background: #EA8063;
      border-radius: 50%;
    }
  }

  .timeline-div {
    height: 1150px;

    .timeline-bg {
      width: 352px;
      height: 695px;
      position: absolute;
      right: 0;
      bottom: 0;
      opacity: 0;
      transform: translateX(50px);
      transition: all 0.8s ease-out 0.3s;
    }

    ::-webkit-scrollbar {
      width: 0 !important;
      height: 0 !important;
      background-color: #fff;
    }

    .section-content {
      width: 100%;
      height: 100%;
    }

    // section头部动画继承
    .section-header {
      opacity: 0;
      transform: translateY(-20px);
      transition: all 0.6s ease-out;
    }

    &.animate-in {
      .section-header {
        opacity: 1;
        transform: translateY(0);
      }

      .timeline-bg {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .timeline-years {
      // 年份列表滚动容器
      > .flex1.overflow-auto {
        scroll-behavior: smooth;
      }

      // 年份项包裹容器
      .timeline-items-wrapper {
        position: relative;
        padding: 10px 0;
      }

      // 连接线 - 每个时间项之间的连接线
      .timeline-line-segment {
        position: absolute;
        left: 20px;
        top: 20px;
        bottom: -20px;
        width: 2px;
        background: #F7CCC1;
        opacity: 0;
        transform: scaleY(0);
        transform-origin: top;
        transition: all 0.8s ease-out 0.3s;
        z-index: 1;
      }

      // 箭头按钮动画
      .arrow-btn {
        transition: all 0.3s ease;
        cursor: pointer;

        &:active {
          transform: scale(1.1);
        }
      }

      .arrow-up {
        animation: arrowFloat 2s ease-in-out infinite;
      }

      .arrow-down {
        animation: arrowFloat 2s ease-in-out infinite 1s;
      }

      .timeline-year-item {
        opacity: 0;
        transform: translateX(-30px);
        animation: slideInLeft 0.6s ease-out forwards;
        transition: all 0.3s ease;
        padding-bottom: 70px;
        border-radius: 6px;
        margin-right: 15px;

        &:last-child {
          padding-bottom: 0;
        }

        &:active {
          transform: translateX(8px);
        }

        &.timeline-year-active {
          transform: translateX(10px);
        }

        .point-wrapper {
          position: relative;
          z-index: 2;
        }

        .point {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #F7CCC1;
          transition: all 0.3s ease;
          position: relative;

          &-a {
            background: #EB8063;
            border: 10px solid #F7CCC1 !important;
          }
        }

        // 脉冲动画
        .point-pulse {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: rgba(235, 128, 99, 0.4);
          transform: translate(-50%, -50%);
          animation: pulse 2s ease-out infinite;
        }

        .timeline-year {
          font-size: 35px !important;
          color: #a1a6ad;
          transition: all 0.3s ease;

          &.year-active {
            color: #454F5E !important;
            font-weight: 600;
          }
        }

        .timeline-desc {
          font-size: 25px !important;
          color: #454F5E;
          transition: all 0.3s ease;

          &.desc-active {
            color: #2C2B30;
          }
        }
      }
    }

    // 连接线动画
    &.animate-in .timeline-line-segment {
      opacity: 1;
      transform: scaleY(1);
    }
  }

  .ps1 {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #EB8063;
  }

  .ps2 {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #EB8063;
  }
}

.home-page {
  width: 100%;
  scroll-behavior: smooth;
  overflow: hidden;

  // 窄屏模式下的全局适配
  &.mobile-mode {
    .section-content {
      width: 100% !important;
      max-width: 100vw;
      box-sizing: border-box;
    }
  }
}

// 滚动动画
.animate-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;

  &.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
}

// 产品图片切换动画
.product-image-container {
  .fade-scale-enter-active {
    transition: all 0.5s ease;
  }

  .fade-scale-leave-active {
    transition: all 0.3s ease;
  }

  .fade-scale-enter-from {
    opacity: 0;
    transform: scale(0.9);
  }

  .fade-scale-leave-to {
    opacity: 0;
    transform: scale(1.05);
  }
}

// 学术资讯卡片动画
.animate-card {
  opacity: 0;
  transform: translateY(30px);
  animation: cardFadeIn 0.6s ease-out forwards;
  overflow: hidden;
  cursor: pointer;

  // 图片容器
  .academic-image-wrapper {
    overflow: hidden;
    position: relative;
    border-radius: 4px 4px 0 0;
  }

  // 图片样式
  .academic-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: transform;
  }

  // 文字初始样式
  .academic-text {
    opacity: 0.75;
    transition: all 0.5s ease-out;
    transform: translateY(0);
  }

  // 悬停效果
  &:hover {
    // 图片放大
    .academic-image {
      transform: scale(1.15);
    }

    // 文字渐入，并轻微上移
    .academic-text {
      opacity: 1;
      transform: translateY(-2px);
    }
  }
}

@keyframes cardFadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes tabFadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes barExpand {
  to {
    opacity: 1;
    transform: scaleX(1);
  }
}

// 徽章样式
.product-category-title {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 500;
  color: #013D5C;
  margin-left: 24%;

  &.animate-fade-in {
    animation: fadeIn 1s ease-out 0.2s both;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

// 产品区样式
.product-section {
  .color-bars {
    .color-bar {
      opacity: 0;
      transform: scaleX(0);
      transform-origin: left;
      animation: barExpand 0.8s ease-out forwards;
    }
  }

  .product-tab-new {
    flex: 1;
    max-width: 360px;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

    &.animate-tab {
      opacity: 0;
      transform: translateY(30px);
      animation: tabFadeIn 0.6s ease-out forwards;
    }

    .tab-number-badge {
      width: 40px;
      height: 40px;
      line-height: 40px;
      border-radius: 16px;
      border: 2px solid #CCCCCC;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: #CCCCCC;
      background: transparent;
      transition: all 0.3s;

      span {
        font-family: Arial, sans-serif;
      }
    }

    .tab-name {
      font-size: 32px;
      font-weight: 400;
      color: #ABBFCA;
      text-align: center;
      transition: all 0.3s;
      word-break: keep-all;
      padding-bottom: 10px;
      border-bottom: 6px solid transparent;
    }

    &:hover {
      transform: translateY(-5px);

      .tab-number-badge {
        border-color: #EA8063;
        color: #EA8063;
        box-shadow: 0 4px 12px rgba(234, 128, 99, 0.2);
      }

      .tab-name {
        color: #EA8063;
      }
    }

    &.product-tab-new-active {
      .tab-number-badge {
        border-color: #EA8063;
        background: #EA8063;
        color: #FFFFFF;
      }

      .tab-name {
        color: #013D5C;
        font-weight: 500;
        border-bottom: 6px solid #EA8063;
      }

      .tab-underline {
        background: #EA8063;
      }
    }
  }
}

// 使命区样式
.mission-section {
  .mission-content {
    width: 100%;

    .mission-image {
      width: 665px;
      height: 781px;
    }

    .animate-slide-left {
      opacity: 0;
      transform: translateX(-60px);
      transition: all 0.8s ease-out 0.2s;
    }

    .animate-slide-right {
      opacity: 0;
      transform: translateX(60px);
      transition: all 0.8s ease-out 0.4s;
    }
  }

  &.animate-in {
    .animate-slide-left,
    .animate-slide-right {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .mission-text {
    position: absolute;
    right: 20%;
    top: 50%;
    transform: translateY(-50%) !important;

    .mission-title {
      font-size: 68px;
      color: #013D5C;
      line-height: 1.5;
    }

    .mission-desc {
      font-size: 16px;
      color: #666666;
      line-height: 1.8;
    }

    .mission-btn {
      display: inline-flex;
      align-items: center;
      padding: 12px 30px;
      background: #EA8063;
      color: #FFFFFF;
      border-radius: 25px;
      font-size: 16px;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 4px 12px rgba(234, 128, 99, 0.3);

      &:hover {
        background: #FF8C4D;
        transform: translateX(10px) scale(1.05);
        box-shadow: 0 6px 20px rgba(234, 128, 99, 0.5);
      }
    }
  }
}

// 发展历程样式
.timeline-section {
  height: 940px;

  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
    background-color: #fff;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  // 背景图片动画
  .timeline-bg-image {
    transition: transform 0.8s ease-out;
  }

  &.animate-in .timeline-bg-image {
    animation: bgZoomIn 1.2s ease-out both;
  }

  // 左侧面板
  .timeline-left-panel {
    flex-shrink: 0;
    margin-left: 170px;
  }

  // 标题区域动画
  .timeline-header {
    opacity: 0;
    transform: translateY(-30px);
    transition: all 0.8s ease-out;
    position: absolute;
    left: 380px;
    top: 100px;
  }

  &.animate-in .timeline-header {
    opacity: 1;
    transform: translateY(0);
  }

  .timeline-icon {
    animation: iconBounce 0.8s ease-out 0.3s both;
  }

  .timeline-title {
    animation: titleSlide 0.8s ease-out 0.4s both;
  }

  // 年份选择器样式
  .timeline-years-selector {
    max-height: 600px;

    // 箭头按钮动画
    .arrow-btn {
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      cursor: pointer;

      &:hover {
        transform: scale(1.2);
      }

      &:active {
        transform: scale(1.1);
      }
    }

    .arrow-up {
      animation: arrowFloat 2s ease-in-out infinite;
    }

    .arrow-down {
      animation: arrowFloat 2s ease-in-out infinite 1s;
    }

    .timeline-year-selector-item {
      font-size: 22px;
      color: #D0DDF0;
      padding: 35px 0;
      transition: all 0.3s ease;
      font-family: font-n, serif;

      &:hover {
        color: #013D5C;
      }

      &.year-selector-active {
        color: #013D5C;
      }
    }
  }

  // 右侧卡片区域
  .timeline-right-cards {
    position: relative;
    overflow: visible;

    .timeline-card {
      position: absolute;
      opacity: 1;
      transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      width: 550px;

      .timeline-card-year {
        font-size: 60px;
        color: #1B4450;
        line-height: 1.2;
        display: inline-block;
        margin-bottom: 8px;
      }

      .timeline-card-desc {
        font-size: 24px;
        color: #454F5E;
        line-height: 1.4;
        border-top: 2px solid #55D0FC;
        padding-right: 80px;
        padding-top: 10px;
      }

      // 不同位置的卡片动画延迟
      &.timeline-card-0 {
        transition-delay: 0.1s;
      }

      &.timeline-card-1 {
        transition-delay: 0.2s;
      }

      &.timeline-card-2 {
        transition-delay: 0.3s;
      }

      &.timeline-card-3 {
        transition-delay: 0.4s;
      }
    }
  }

  // 动画进入时显示卡片
  &.animate-in .timeline-right-cards .timeline-card {
    opacity: 1;
  }

  // 卡片容器
  .timeline-cards-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  // 切换年份时的卡片动画 - 从左往右移入
  .timeline-card-slide-enter-active {
    transition: opacity 0.5s ease-out, transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
  }

  .timeline-card-slide-leave-active {
    transition: opacity 0.25s ease-out, transform 0.3s ease-out !important;
    position: absolute;
  }

  .timeline-card-slide-enter-from {
    opacity: 0 !important;
    transform: translateX(-100px) !important;
  }

  .timeline-card-slide-leave-to {
    opacity: 0 !important;
    transform: translateX(60px) !important;
  }

  // 卡片依次从左往右移入的延迟
  .timeline-card-slide-enter-active.timeline-card-0 {
    transition-delay: 0s !important;
  }

  .timeline-card-slide-enter-active.timeline-card-1 {
    transition-delay: 0.12s !important;
  }

  .timeline-card-slide-enter-active.timeline-card-2 {
    transition-delay: 0.24s !important;
  }

  .timeline-card-slide-enter-active.timeline-card-3 {
    transition-delay: 0.36s !important;
  }
}

// 发展历程动画关键帧
@keyframes slideInLeft {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes bgZoomIn {
  from {
    opacity: 0.8;
    transform: scale(1.05);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes iconBounce {
  0% {
    opacity: 0;
    transform: scale(0) rotate(-180deg);
  }
  60% {
    transform: scale(1.2) rotate(10deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
}

@keyframes titleSlide {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes arrowFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }
  100% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0;
  }
}

@keyframes pointActive {
  0% {
    transform: scale(0.5);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes textPulse {
  0% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}

// 企业动态样式
.news-section {
  .news-desc {
    max-width: 90%;
  }

  .animate-slide-left {
    opacity: 0;
    transform: translateX(-60px);
    transition: all 0.8s ease-out 0.2s;
  }

  .animate-slide-right {
    opacity: 0;
    transform: translateX(60px);
    transition: all 0.8s ease-out 0.4s;
  }

  &.animate-in {
    .animate-slide-left,
    .animate-slide-right {
      opacity: 1;
      transform: translateX(0);
    }
  }
}

.more-link {
  padding: 0 15px;
  height: 43px;
  line-height: 43px;
  text-align: center;
  border-radius: 21px 21px 21px 21px;
  border: 1px solid #EA8063;
  font-size: 18px;
  color: #EA8063;
  transition: all 0.3s ease;

  &:hover {
    background: #EA8063;
    color: #FFFFFF;
    transform: translateX(5px);
  }
}

// 学术资讯样式
.academic-section {
  .academic-title-wrapper {
    opacity: 0;
    transform: translateX(-30px);
    transition: all 0.8s ease-out 0.2s;
  }

  &.animate-in {
    .academic-title-wrapper {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .item-academic {
    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  .academic-content {
    border-left: 12px solid #EA8063;

    .academic-category {
      font-size: 12px;
      color: #999999;
    }

    .academic-title {
      font-size: 16px;
      font-weight: 500;
      color: #013D5C;
      line-height: 1.5;
    }

    .academic-desc {
      font-size: 14px;
      color: #666666;
    }
  }
}

// ==================== 窄屏适配样式 ====================
.home-page.mobile-mode {
  // Banner 适配 - 保持与PC端相似的比例
  .banner-section {
    .section-content {
      padding: 0 !important;
    }

    .banner-item {
      position: relative;
      width: 100%;
      height: 1020px;
      // 保持16:9的宽高比，类似PC端效果
      aspect-ratio: 16 / 9;
      overflow: hidden;

      .banner-bg {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .banner-content {
        position: absolute;
        top: 25%;
        left: 8%;
        display: flex;
        flex-direction: column;
        font-size: 87px;
        line-height: 80px;
        color: #454F5E;
      }
    }
  }
}
</style>
